import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AccessibilityService } from './accessibility.service';

interface AlertParams {
    message: string;
    buttonApprove: string;
    buttonCancel: string;
    inverted?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    private accessibilityService = inject(AccessibilityService);
    private elementToFocusOnClose: HTMLElement|null = null;

    ALERT_MODAL_ID = 'alertModal';

    static TASKS_CONFIRMATION: AlertParams = {
        message: 'Achtung: Wenn die Sidebar geschlossen wird,<br> ' +
            'werden nicht gespeicherte Änderungen verworfen und hinzugefügte Aufgaben nicht gespeichert.',
        buttonApprove: 'Verwerfen',
        buttonCancel: 'Weiterarbeiten',
        inverted: true
    };
    static HOMEWORK_CONFIRMATION: AlertParams = {
        message: 'Achtung: Wenn die Sidebar geschlossen wird, <br> ' +
            'werden nicht gespeicherte Änderungen verworfen und hinzugefügte Aufgaben nicht gespeichert.',
        buttonApprove: 'Verwerfen',
        buttonCancel: 'Weiterarbeiten',
        inverted: true
    };

    isVisible = false;
    message: Subject<string> = new Subject();
    message$: Observable<string> = this.message.asObservable();
    btnApprove: Subject<string> = new Subject();
    btnApprove$: Observable<string> = this.btnApprove.asObservable();
    btnCancel: Subject<string> = new Subject();
    btnCancel$: Observable<string> = this.btnCancel.asObservable();
    inverted: Subject<boolean> = new Subject();
    inverted$: Observable<boolean> = this.inverted.asObservable();

    private resolveFn: (value: boolean) => void;

    alert(settings: AlertParams): Promise<boolean> {
        this.elementToFocusOnClose = document.activeElement as HTMLElement;
        this.isVisible = true;
        this.message.next(settings.message);
        this.btnApprove.next(settings.buttonApprove);
        this.btnCancel.next(settings.buttonCancel);
        if (settings.inverted) {
            this.inverted.next(settings.inverted);
        }

        setTimeout(() => {
            this.accessibilityService.focusElementById(this.ALERT_MODAL_ID);
            }, 50);

        return new Promise<boolean>((resolve) => {
            this.resolveFn = resolve;
        });
    }

    onApprove() {
        this.isVisible = false;
        this.restoreFocus();
        this.resolveFn(true);
    }

    onCancel() {
        this.isVisible = false;
        this.restoreFocus();
        this.resolveFn(false);
    }

    private restoreFocus() {
        if (this.elementToFocusOnClose) {
            this.accessibilityService.focusElement(this.elementToFocusOnClose);
            this.elementToFocusOnClose = null;
        }
    }
}
